import './App.css';
import { useEffect, useState } from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import HotelList from './components/hotel-list/hotel-list';
import CacheView from './components/cache-view/cache-view';
import request from './internal/request';
import Actions from './components/actions/actions';

export function API_ADDR(): string {
  const myUrl = window.document.URL
  if (myUrl.includes(":3000")) {
    // Debugging, return the URL but port 8080 (debugging port)
    return myUrl.replace(":3000", ":8080").slice(0, myUrl.indexOf(":3000/") + 5)
  }
  return ""
}

export default function App() {
  const [runtimeEnv, setRuntimeEnv] = useState("")
  const [activeBrand, setActiveBrand] = useState("")
  const [activeHotel, setActiveHotel] = useState("")
  const [getHotel, setHotel] = useState<Hotel>()
  const [getBrands, setBrands] = useState<Brand[]>([])
  const [trigger, setTrigger] = useState(Date.now().toString()) // Use this to trigger a cache view re-render

  useEffect(() => {
    // Get hotel list & runtime environment
    request<Env>(`${API_ADDR()}/api/environment`)
      .then((env) => setRuntimeEnv(env.environment))
    request<Brands>(`${API_ADDR()}/api/brandhotels`)
      .then((brands) => setBrands(brands.brands))

  }, [])

  const hotelSelected = (brand: string, hotel?: Hotel) => {
    // Update the brand and hotel
    setActiveBrand(brand)
    setActiveHotel(hotel?.hotel_reference_id ?? "")
    setHotel(hotel)
  }

  const updateCacheView = () => {
    setTrigger(Date.now().toString())
  }

  return (
    <div className="app">
      <Container fluid>
        <Row className='banner header top'>
          <Col xs={1}><img style={{ height: "6vh" }} src={process.env.PUBLIC_URL + "/logo.svg"} className='logo' alt='Ennismore logo' /></Col>
          <Col style={{ textAlign: "center", border: "1px solid white", marginRight: 25 }}>The Ennismore CMS Cache Manager</Col>
        </Row>
        <Row>
          <Col xs={3} className='content' style={{ alignItems: "stretch" }}>
            <HotelList brands={getBrands} setActiveHotel={hotelSelected} />
          </Col>
          <Col className='content' >
            <CacheView runtimeEnv={runtimeEnv} brandCode={activeBrand} hotelReferenceId={activeHotel} hotel={getHotel} reRender={trigger} />
          </Col>
          <Col xs={2} className='content' style={{ alignItems: "stretch", justifyContent: "flex-start", border: "1px solid white" }}>
            <Actions runtimeEnv={runtimeEnv} brands={getBrands} activeBrand={activeBrand} trigger={updateCacheView} />
          </Col>
        </Row>
        <Row>
          <Col style={{ marginTop: 5, borderTop: "1px solid silver", textAlign: "right", fontWeight: "bold" }}>Runtime environment: {runtimeEnv}</Col>
        </Row>
      </Container>
    </div>
  );
}

export interface Brands {
  brands: Brand[]
}

export interface Brand {
  hotels: Hotel[]
  brand_code: string
}

export interface Hotel {
  name: string
  visibility: string
  hotel_reference_id: string
}

interface Env {
  environment: string
}